import React from 'react';
import MainAffiliateAgent from '../../components/Main/MainPolicy/MainAffiliateAgent';

export default function AffiliateAgent(){
    return(
        <div>
           <MainAffiliateAgent />
        </div>
    )
}
